import { useState, useEffect } from 'react';
import { useRouter } from 'next/router';

export function useLoadingPage() {
  const [loading, setLoading] = useState(true);
  const router = useRouter();

  useEffect(() => {
    let timeoutId;

    // Chỉ show loader lần đầu vào app
    if (loading) {
      timeoutId = setTimeout(() => setLoading(false), 1500); // min 1.5s
    }

    const handleComplete = () => {
      setLoading(false);
    };

    router.events.on('routeChangeComplete', handleComplete);
    router.events.on('routeChangeError', handleComplete);

    return () => {
      clearTimeout(timeoutId);
      router.events.off('routeChangeComplete', handleComplete);
      router.events.off('routeChangeError', handleComplete);
    };
  }, [loading, router.events]);

  return { loading };
}
